module.exports = __webpack_public_path__ + "img/municipio-dinamico.f192adb3.jpg";